import { render, staticRenderFns } from "./SubjectSelector.vue?vue&type=template&id=8010b1f0&scoped=true&"
import script from "./SubjectSelector.vue?vue&type=script&lang=js&"
export * from "./SubjectSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8010b1f0",
  null
  
)

export default component.exports